export type IssueType = 
  | 'wrong_brand'
  | 'wrong_model'
  | 'wrong_family'
  | 'wrong_variant'
  | 'wrong_valuation'
  | 'wrong_condition'
  | 'other';

export type ReportStatus = 'pending' | 'in_review' | 'resolved' | 'rejected';
export type ReportPriority = 'low' | 'medium' | 'high';

export interface ProductIssueReport {
  id: string;
  user_product_id: string;
  user_id: string;
  
  // Issue details
  issue_type: IssueType;
  reported_field?: string;
  current_value?: string;
  suggested_value?: string;
  description?: string;
  
  // Status
  status: ReportStatus;
  priority: ReportPriority;
  
  // Admin response
  admin_notes?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  resolution_action?: string;
  
  // Metadata
  created_at: string;
  updated_at: string;
}

export interface ProductIssueReportWithProduct extends ProductIssueReport {
  user_product?: {
    id: string;
    valuation?: number;
    condition?: string;
    images?: Array<{ storage_path: string }>;
    variant?: {
      id: string;
      attributes?: any;
      model?: {
        id: string;
        name: string;
        family?: {
          id: string;
          name: string;
          brand?: {
            id: string;
            name: string;
          };
        };
      };
    };
  };
}

export interface CreateIssueReportInput {
  user_product_id: string;
  issue_type: IssueType;
  reported_field?: string;
  current_value?: string;
  suggested_value?: string;
  description?: string;
  priority?: ReportPriority;
}

export interface UpdateIssueReportInput {
  status?: ReportStatus;
  priority?: ReportPriority;
  admin_notes?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  resolution_action?: string;
}

export const ISSUE_TYPE_LABELS: Record<IssueType, string> = {
  wrong_brand: 'Wrong Brand',
  wrong_model: 'Wrong Model',
  wrong_family: 'Wrong Product Family',
  wrong_variant: 'Wrong Variant/Specs',
  wrong_valuation: 'Wrong Valuation',
  wrong_condition: 'Wrong Condition',
  other: 'Other Issue',
};

export const STATUS_LABELS: Record<ReportStatus, string> = {
  pending: 'Pending Review',
  in_review: 'In Review',
  resolved: 'Resolved',
  rejected: 'Rejected',
};

export const PRIORITY_LABELS: Record<ReportPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};
